class MarsoAnnouncementMarquee extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.track = this.querySelector('.marquee');
    this.speed = Number.parseInt(this.dataset.speed, 10) || 20;
    this.direction = this.dataset.direction || 'left';
    this.setup = this.setup.bind(this);

    requestAnimationFrame(this.setup);
    window.addEventListener('resize', this.setup, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.setup);
  }

  setup() {
    if (!this.track) return;

    this.track.querySelectorAll('[data-marso-marquee-clone]').forEach((clone) => clone.remove());

    const items = Array.from(this.track.children).filter((item) => !item.hasAttribute('data-marso-marquee-clone'));
    const baseWidth = this.track.scrollWidth;
    const containerWidth = this.clientWidth;

    if (!baseWidth || !containerWidth || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const copies = Math.max(1, Math.ceil(containerWidth / baseWidth) + 1);
    for (let copy = 0; copy < copies; copy += 1) {
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-marso-marquee-clone', '');
        clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      });
    }

    const widthRatio = Math.min(2.5, Math.ceil(baseWidth / containerWidth));
    const duration = Math.max(8, (33 - this.speed) * widthRatio);
    this.style.setProperty('--marso-marquee-distance', `${baseWidth}px`);
    this.style.setProperty('--marso-marquee-duration', `${duration}s`);
    this.track.classList.remove('marso-marquee-animated--left', 'marso-marquee-animated--right');
    this.track.classList.add(`marso-marquee-animated--${this.direction}`);
  }
}

if (!window.customElements.get('marso-announcement-marquee')) {
  window.customElements.define('marso-announcement-marquee', MarsoAnnouncementMarquee);
}

class MarsoAnnouncementCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.slides = Array.from(this.querySelectorAll('.marso-announcement-bar__slide'));
    this.index = 0;

    if (this.slides.length < 2 || !this.hasAttribute('data-autoplay')) return;

    const delay = Number.parseInt(this.getAttribute('data-autoplay-speed'), 10) || 5;
    this.timer = window.setInterval(() => this.show(this.index + 1), delay * 1000);

    this.addEventListener('mouseenter', () => window.clearInterval(this.timer));
    this.addEventListener('mouseleave', () => {
      this.timer = window.setInterval(() => this.show(this.index + 1), delay * 1000);
    });

    document.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleBlockSelect = (event) => {
    const index = this.slides.indexOf(event.target);
    if (index >= 0) this.show(index);
  };

  show(nextIndex) {
    this.index = nextIndex % this.slides.length;

    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.toggleAttribute('aria-hidden', !active);
      slide.querySelectorAll('a, button').forEach((element) => {
        element.toggleAttribute('tabindex', !active);
      });
    });
  }
}

if (!window.customElements.get('marso-announcement-carousel')) {
  window.customElements.define('marso-announcement-carousel', MarsoAnnouncementCarousel);
}
